export default __webpack_public_path__ + "static/media/login.ef3d078d.jpg";